import { Controller } from "@hotwired/stimulus";

// Drives the lesson-element creation modal: switches between panes (Texte,
// Vidéo, Image, Fichier, QCM, Dépot de fichier) when the user picks a type.
export default class extends Controller {
  static targets = ["typeCard", "pane", "contentField"];
  static values  = { current: String };

  connect() {
    this._showCurrent();
  }

  pickType(event) {
    const card = event.currentTarget;
    const type = card.dataset.type;
    if (!type) return;

    this.currentValue = type;

    // Visually toggle the card highlight.
    this.typeCardTargets.forEach((c) => c.classList.toggle("is-active", c === card));

    // Force the radio inside the card to be checked, even if the click
    // happened on the icon/label (browsers don't always toggle the radio
    // automatically when the click target is a child of the label).
    const radio = card.querySelector('input[type="radio"]');
    if (radio) radio.checked = true;

    this._showCurrent();
  }

  _showCurrent() {
    const current = this.currentValue;
    this.paneTargets.forEach((pane) => {
      const types = (pane.dataset.types || "").split(",").map((t) => t.trim());
      const visible = types.includes(current);
      pane.hidden = !visible;
      // Disable inputs in hidden panes so their value isn't POSTed alongside
      // the visible pane's input. Without this, the QCM hidden field with
      // its empty `[{"question":"",...}]` skeleton would overwrite the
      // textarea content of every non-QCM element type.
      pane.querySelectorAll("input, textarea, select").forEach((field) => {
        // Don't touch the radio buttons that drive the type picker — they
        // live OUTSIDE the panes (in the type catalog), but we exclude
        // them defensively in case the markup ever changes.
        if (field.type === "radio" && field.name === "lesson_element[element_type]") return;
        field.disabled = !visible;
      });
    });
  }
}
